/*eslint-disable */
// import TprepSessionModel from '../../Model/TprepSession'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let TprepAnalytics =  {
  /**
   * tprep_analyticsPerformanceTrend
   */
  async tprep_analyticsPerformanceTrend (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (key == "whereFilter") {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }
      
      return await request.curl(context, "tprep_analytics_get", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsPerformanceTrend() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprep_analyticsGetAttemptedAppsForExam
   */
  async tprep_analyticsGetAttemptedAppsForExam (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (payload.whereFilter) {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }
      
      return await request.curl(context, "tprep_analytics_get_attempted_apps_for_exam", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsGetAttemptedAppsForExam() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprep_analyticsMonthWiseMocksTaken
   */
  async tprep_analyticsMonthWiseMocksTaken (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (payload.whereFilter) {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }
      
      return await request.curl(context, "tprep_analytics_month_wise_mocks_taken", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsMonthWiseMocksTaken() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprep_analyticsAttemptedMocksResultAnalysis
   */
  async tprep_analyticsAttemptedMocksResultAnalysis (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (payload.whereFilter) {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }
      
      return await request.curl(context, "tprep_analytics_attempted_mocks_result_analysis", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsAttemptedMocksResultAnalysis() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprep_analyticsHomepagePerfomaceData
   */
  async tprep_analyticsHomepagePerfomaceData (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (payload.whereFilter) {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }
      
      return await request.curl(context, "tprep_analytics_homepage_perfomace_data", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsHomepagePerfomaceData() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprep_analyticsStackedColumnData
   */
  async tprep_analyticsStackedColumnData (context, payload=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key] === null || payload[key] === undefined) {
          continue;
        }
        if (key == "whereFilter") {
          post_data.append('filter', JSON.stringify(payload.whereFilter))
        }
        else {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "tprep_analytics_stacked_column_data", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_analyticsStackedColumnData() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * tprepAnalyticsResultInsightsGenerate
   */
  async tprepAnalyticsResultInsightsGenerate (context, appResultObj) {
    try {      
      let post_data = new FormData();
      for (let key in appResultObj) {
        if (appResultObj[key] || typeof appResultObj[key] == 'number') {
          post_data.append(key, appResultObj[key]);
        }
      }

      return await request.curl(context, "tprep_analytics_result_insights_generate", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at tprepAnalyticsResultInsightsGenerate() and Exception:",err.message)
    }    
  },

  /**
   * tprep_analytics_readyness_accuracy_focus_strength_view
   */
  async tprepAnalyticsGetReadynessAccuracyFocusStrength (context, payload = null) {
    try {
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";
  
      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key] !== null && payload[key] !== undefined) {
          if (typeof payload[key] === 'object') {
            post_data.append(key, JSON.stringify(payload[key]));
          }
          else {
            post_data.append(key, payload[key]);
          }
        }
      }
  
      return await request.curl(context, "tprep_analytics_readyness_accuracy_focus_strength_view", post_data)
        .then(async response => {
          return response;
        });
    }
    catch (err) {
      console.error('Exception occurred at tprep_analytics_readyness_accuracy_focus_strength_view() and Exception:', err.message);
      return { resp_status: false, resp_code: "ERR_EXCEPTION", resp_msg: err.message };
    }
    finally {
      Utility.showLoader = false;
    }
  }
}

export {
  TprepAnalytics
}
